import React from 'react'
import { Link, useSearchParams } from 'react-router-dom'

import type { PartialDeep } from 'type-fest'

import { useTrackEvent } from '@ztechapps/webui.telemetry'

import { routesDef } from '../../config/routes'
import type { QueryFilter } from '../../config/types'

type LinkToProductSearchProps = {
  children: React.ReactNode
  className?: string
  category?: { value: string; label: string }
  skip?: number
  search?: string
} & PartialDeep<QueryFilter>

export const LinkToProductSearch = ({ children, className, category, ...args }: LinkToProductSearchProps) => {
  const trackEvent = useTrackEvent()

  const [searchParams] = useSearchParams()
  const searchParamsObj = React.useMemo(() => {
    return Object.fromEntries(searchParams)
  }, [searchParams])

  const finalArgs = React.useMemo(() => {
    return {
      ...searchParamsObj,
      ...args,
    }
  }, [args, searchParamsObj])

  return (
    <Link
      to={routesDef.ProductListPage.altPath(finalArgs)}
      className={className}
      onClick={() => {
        trackEvent('Category filter', {
          category_label: category?.label ?? 'All categories',
          category_value: category?.value ?? '',
        })
      }}
    >
      {children}
    </Link>
  )
}
